"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./create-invoice.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./create-invoice.component");
var i3 = require("@angular/router");
var i4 = require("@angular/material/dialog");
var styles_CreateInvoiceComponent = [i0.styles];
var RenderType_CreateInvoiceComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CreateInvoiceComponent, data: {} });
exports.RenderType_CreateInvoiceComponent = RenderType_CreateInvoiceComponent;
function View_CreateInvoiceComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_CreateInvoiceComponent_0 = View_CreateInvoiceComponent_0;
function View_CreateInvoiceComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ruckit-create-invoice", [], null, null, null, View_CreateInvoiceComponent_0, RenderType_CreateInvoiceComponent)), i1.ɵdid(1, 114688, null, 0, i2.CreateInvoiceComponent, [i3.ActivatedRoute, i3.Router, i4.MatDialog], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_CreateInvoiceComponent_Host_0 = View_CreateInvoiceComponent_Host_0;
var CreateInvoiceComponentNgFactory = i1.ɵccf("ruckit-create-invoice", i2.CreateInvoiceComponent, View_CreateInvoiceComponent_Host_0, {}, {}, []);
exports.CreateInvoiceComponentNgFactory = CreateInvoiceComponentNgFactory;
